import React, { useEffect, useState } from 'react';
import { Clock } from 'lucide-react';
const TOTAL_SECONDS = 45 * 60;
export function CountdownTimer() {
  const [seconds, setSeconds] = useState(TOTAL_SECONDS);
  useEffect(() => {
    const interval = setInterval(() => {
      setSeconds(prev => prev > 0 ? prev - 1 : 0);
    }, 1000);
    return () => clearInterval(interval);
  }, []);
  const mins = Math.floor(seconds / 60);
  const secs = seconds % 60;
  const pad = (n: number) => n.toString().padStart(2, '0');
  return <div className="fixed top-0 left-0 right-0 z-50 bg-[#111] border-b border-brand/20" data-id="element-1">
      <div className="max-w-3xl mx-auto flex items-center justify-center gap-3 px-4 py-2.5" data-id="element-2">
        <Clock size={16} className="text-brand shrink-0" data-id="element-3" />
        <span className="text-sm md:text-base text-zinc-400 font-medium" data-id="element-4">
          OFERTA POR TIEMPO LIMITADO: La oferta expira en:
        </span>
        <div className="flex items-center gap-1 font-display text-brand font-bold text-lg md:text-xl tracking-wider" data-id="element-5">
          <span className="bg-brand/10 border border-brand/30 px-2 py-0.5 rounded" data-id="element-6">
            {'44'}
          </span>
          <span className="text-brand animate-pulse" data-id="element-7">:</span>
          <span className="bg-brand/10 border border-brand/30 px-2 py-0.5 rounded" data-id="element-8">
            {pad(secs)}
          </span>
        </div>
      </div>
    </div>;
}